import { trackMoveAction } from '../../_common/client/tracking';

export const addMoveTrackingToLink = (linkElement: HTMLElement) => {
    const moveActionTrackingLabelValue = linkElement.dataset.moveActionTrackingLabelValue;
    if (moveActionTrackingLabelValue) {
        linkElement.addEventListener('click', () => {
            trackMoveAction(
                { ot_PageCluster: ['Artikeldetailseite'], review_Navigation: [moveActionTrackingLabelValue] },
                { name: 'click', features: [] }
            );
        });
    }
};
